import { Llm as Responder } from 'data/firestore/agent/llm/types';

const isConversationalResponder = (config?: Responder) => config?.featureSchema && [
    'system.meta.chat',
    'system.call.incoming',
    'system.call.outbound',
].includes(config.featureSchema);

export default isConversationalResponder;
